// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-cheum a{display:block;padding:0.3em 1em;margin:0.25em 0;font-size:1.5rem;border-radius:.2rem;border:0;color:#4b607e;transition:color 0.5s ease-in-out}.menu-cheum a:hover,.menu-cheum a:active,.menu-cheum .active a{background-color:#e0edff;color:#104182}\n", ""]);
// Exports
module.exports = exports;
